module.exports = __webpack_public_path__ + "img/zsgg-6.a0406ab7.png";